import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Chat } from '../../chat/chat';
import { ChatPageState } from '../chat-page.state';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';
import { MibButtonComponent, MibIconsModule } from '@medinbox/angular';

@Component({
  selector: 'app-chat-tab',
  imports: [Chat, MibButtonComponent, MibIconsModule],
  templateUrl: './chat-tab.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatTab {
  protected readonly state = inject(ChatPageState);
  readonly isMinimized = computed(
    () => !this.state.isSmall() && this.state.tabState().chat === 'minimized',
  );
  readonly isHidden = toSignal(toObservable(this.isMinimized).pipe(debounceTime(100)), {
    initialValue: false,
  });

  //FIXME: wire hasMessage to a real flag
  readonly hasMessages = signal(false);

  toggleTab(): void {
    this.state.toggleChat();
  }
}
